// @ts-ignore

import { defineNuxtPlugin } from '#app'
import VueSelect from 'vue-select'
export default defineNuxtPlugin((nuxtApp: any) => {
    nuxtApp.vueApp.component('v-select', VueSelect)
})
